import { useSearchParams } from 'react-router-dom'
import { useAppSelector } from 'store'

import { getUserDefaultCountry } from 'services/authSlice'

export const useHandleSearchParams = () => {
  const defaultCountry = useAppSelector(getUserDefaultCountry)
  const [searchParams] = useSearchParams()

  const producent = searchParams.get('brand') || ''
  const element = searchParams.get('product') || ''
  const asset = searchParams.get('asset') || ''
  const country = searchParams.get('country') || defaultCountry || 'PL'
  const size = Number(searchParams.get('size') || 8)
  const page = Number(searchParams.get('page') || 1)
  const searchQuery = searchParams.get('search') || ''

  const orderBy = searchParams.get('orderBy') || 'createdAt'
  const orderDir = searchParams.get('orderDir') || 'desc'

  const sku = searchParams.get('sku') || ''
  const name = searchParams.get('name') || ''
  const brand = searchParams.get('brand') || 'all'
  const brandId = searchParams.get('brandId') || ''
  const category = searchParams.get('category') || 'all'
  const drafts = searchParams.get('drafts') || 'all'
  const shortName = searchParams.get('shortName') || ''
  // also known as product category id.
  const categoryId = searchParams.get('categoryId') || ''

  const assetTypeId = searchParams.get('assetTypeId') || ''
  const assetSubtypeId = searchParams.get('assetSubtypeId') || ''
  const assetId = searchParams.get('assetId') || ''

  const tokenUrl = searchParams.get('token')
  const autoFocus = searchParams.get('autoFocus') || ''

  const creatorOrEditorLabel = searchParams.get('creatorOrEditorLabel') || ''

  const productId = searchParams.get('productId') || ''
  const landingPageId = searchParams.get('landingPageId') || ''
  const partnerId = searchParams.get('partnerId') || ''
  const partnerName = searchParams.get('partnerName') || ''
  const templateId = searchParams.get('templateId') || ''
  const templateName = searchParams.get('templateName') || ''

  const initialPage = searchParams.get('initialPage') || ''
  const initialSize = searchParams.get('initialSize') || ''
  const initialQuery = searchParams.get('initialQuery') || ''

  return {
    asset,
    assetId,
    assetTypeId,
    assetSubtypeId,
    brand,
    brandId,
    category,
    categoryId,
    country,
    creatorOrEditorLabel,
    drafts,
    element,
    name,
    page,
    producent,
    size,
    searchQuery,
    sku,
    tokenUrl,
    autoFocus,
    orderBy,
    orderDir,
    productId,
    landingPageId,
    partnerId,
    partnerName,
    templateId,
    templateName,
    initialPage,
    initialSize,
    initialQuery,
    shortName
  }
}
